
import {
  List,
  Datagrid,
  TextField,
  ExportButton,
  CreateButton,
  TextInput,
  TopToolbar,
  FilterButton,
} from "react-admin";
import ActionsDropdown from "../../components/ActionsDropdown";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";

const postFilters = [<TextInput label="Nome" source="name" alwaysOn />];
const ListActions = () => (
  <TopToolbar>
    {/* <SelectColumnsButton /> */}
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const UserCategoryList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Categoria de Sócios"
        firstPath="/#/user-categories/crud"
        actionType="create"
      />
      <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
        <CardContent>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <List>
                <Datagrid>
                  {/* <TextField source="id" /> */}
                  <TextField source="name" label="Nome" />
                  <ActionsDropdown />
                </Datagrid>
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
